import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { CreateMode, DisplayMode, GridComponent, IGridColumn, IGridSettings, ITableSettings, SortOrder, UpdateMode } from "@features/grid";
import { HistoricalItem } from "@mipro/classes/historical-item";
import { HistoricalItemType, HistoricalItemTypeMap } from "@mipro/classes/historical-item-type";


@Component({
    selector: "m-historical-dialog",
    template: `
        <p-dialog appendTo="body" [(visible)]="visible" [header]="'History'" [modal]="true" [style]="{ 'max-width': '1200px', width: '100%' }">

            <grid [tableSettings]="tableSettings" [gridSettings]="gridSettings"></grid>

            <ng-template pTemplate="footer">
                <div class="flex align-items-center justify-content-end">
                    <button allowOffline pButton type="button" label="Close" (click)="close()">
                        <i class="material-icons">clear</i>
                    </button>
                </div>
            </ng-template>
        </p-dialog>
    `,
    styles: []
})

export class HistoricalDialogComponent {
    private _visible = false;

    @Input()
    set visible(visible: boolean) {
        this._visible = visible;
        this.visibleChange.emit(visible);
    }
    get visible() {
        return this._visible;
    }

    @Input()
    set items(items: HistoricalItem[]) {
        if (!!this.historicalGrid) {
            const gridItems = items?.map((item, index) => ({
                ...item,
                gridTimestamp: `${item.timestamp}_${index}`
            }));

            this.historicalGrid.setTableProperty("value", gridItems ?? []);
        }
    }

    @Output()
    readonly visibleChange = new EventEmitter<boolean>();

    @ViewChild(GridComponent, { static: true })
    historicalGrid: GridComponent;

    gridSettings: IGridSettings = {
        updateMode: UpdateMode.Disabled,
        createMode: CreateMode.Disabled,
        deletingEnabled: false,
    };
    tableSettings: ITableSettings = {
        columns: <IGridColumn[]>[
            { field: "timestamp", header: "Timestamp", displayMode: DisplayMode.Date, displayDateMomentFormat: "DD/MM/YYYY HH:mm:ss" },
            { field: "userEmail", header: "User Email" },
            { field: "userFullName", header: "Full Name" },
            { field: "userType", header: "User Type" },
            { field: "itemType", header: "Operation", displayHandler: (type: HistoricalItemType) => HistoricalItemTypeMap[type] },
            { field: "organizationName", header: "Organisation" },
            { field: "observations", header: "Observations" }
        ],
        lazy: false,
        value: [],
        rowExpandMode: "single",
        dataKey: "gridTimestamp",
        sortField: "timestamp",
        sortOrder: SortOrder.Desc,
        paginatorDropdownAppendTo: "body"
    };

    close() {
        this.visible = false;
    }
}
